import { render } from "./AlertIcon.vue?vue&type=template&id=43df221a"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/AlertIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43df221a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43df221a', __exports__)) {
    api.reload('43df221a', __exports__)
  }
  
  module.hot.accept("./AlertIcon.vue?vue&type=template&id=43df221a", () => {
    api.rerender('43df221a', render)
  })

}


export default __exports__